/* eslint-disable class-methods-use-this */
import {AjaxDataTypes} from '../../../../../../../shared/AjaxDataTypes'
import {UserLoginState} from '../../../../../../../shared/UserLoginState'
import {UIProfileController} from '../../../../../../shared/scripts/profile/UIProfileController'
import {UIProfileRankedSeasonDropdownController} from '../../../../../../shared/scripts/profile/UIProfileRankedSeasonDropdownController'
import {UIMProfileSettingsController} from './UIMProfileSettingController'
import {ColonistMembershipType, LobbyImage} from '@colonist/types'
import {CA} from '../../../../../../shared/scripts/analytics/Analytics'
import {UIProfileGameHistoryController} from '../../../../../../shared/scripts/profile/UIProfileGameHistoryController'
import {ClientUserState} from '../../../../../../shared/scripts/ClientUserState'
import {UIProfileFriendsController} from '../../../../../../shared/scripts/profile/UIProfileFriendsController'
import {UIProfileRankedController} from '../../../../../../shared/scripts/profile/UIProfileRankedController'
import {UIMPopupPlayerSearchView} from '../../../../ui_popup/UIMPopupPlayerSearchView'
import {UIMViewProfilePopup} from '../../../../ui_popup/UIMViewProfilePopup'

export class UIMProfileController extends UIProfileController {
    private gameHistoryController: UIProfileGameHistoryController
    private rankedController: UIProfileRankedController

    constructor(username: string) {
        super()
        this.username = username
        this.initControllers()
        this.init()
        this.initSearchButton()

        const loginButtons = Array.from(document.getElementsByClassName('popup-login-btn')) as HTMLElement[]
        loginButtons.forEach((loginButton) => loginButton.addEventListener('click', () => CA.sendGoogleTagManagerEvent(CA.GoogleTagManagerEvent.UserClickedLoginButton)))

        ClientUserState.registerChangeListener((userState) => {
            document.getElementById('m-profile-container-logged-in')
                ?.classList.toggle('hidden', !userState?.isLoggedIn)
            document.getElementById('m-profile-container-not-logged-in')
                ?.classList.toggle('hidden', userState?.isLoggedIn)
        })
    }

    private initControllers() {
        this.gameHistoryController = new UIProfileGameHistoryController()
        this.rankedController = new UIProfileRankedController(this.username)
        new UIProfileFriendsController(this.username, this.profileLinkController, undefined)
        new UIMProfileSettingsController()
    }

    private initSearchButton() {
        const searchButton = document.getElementById('m-profile-search-button') as HTMLDivElement
        if(searchButton === null) return
        searchButton.addEventListener('click', () => {
            new UIMPopupPlayerSearchView((searchValue: string) => new UIMViewProfilePopup(searchValue))
        })
    }

    getUsername(): string {
        return this.username
    }

    setStickyUsername(username: string): void {
        // TODO: Implement functionality if we add the ability to see other peoples profile without UIMViewProfilePopup.ts
    }
    setUserIcon(iconImage: LobbyImage | undefined): void {
        // TODO: Implement functionality if we add the ability to see other peoples profile without UIMViewProfilePopup.ts
    }
    setMembershipIcon(membershipType: ColonistMembershipType | undefined): void {
        // TODO: Implement functionality if we add the ability to see other peoples profile without UIMViewProfilePopup.ts
    }
    accountDoesNotExist(): void {
        // TODO: Implement functionality if we add the ability to see other peoples profile without UIMViewProfilePopup.ts
    }

    setHistory(historyData: AjaxDataTypes.ProfileHistoryData): void {
        const {gameDatas, profileUserId} = historyData
        this.gameHistoryController.update(gameDatas, this.username, profileUserId)
    }

    setRankedSeasons(seasons: AjaxDataTypes.ProfileDataRankedSeasonDropdown[]): void {
        new UIProfileRankedSeasonDropdownController(seasons, this.rankedController)
    }
    setProfileSettings(userLogins: UserLoginState[]): void {
        return
    }
}

